/* eslint-disable no-console */
const isLogEnabled = process.env.REACT_APP_ENVIRONMENT !== "production";

const getLogger = (caller = "") => ({
  log: (...args) => {
    if (isLogEnabled) console.log(`[${caller}] `, ...args);
  },
  error: (...args) => {
    if (isLogEnabled) console.error(`[${caller}] `, ...args);
  },
  info: (...args) => {
    if (isLogEnabled) console.info(`[${caller}] `, ...args);
  }
});

export default getLogger;
